module.exports = __webpack_public_path__ + "img/alert-bell-icon.1a4ab335.svg";